import React from 'react';
import { Badge, Spinner } from 'react-bootstrap';

const BadgeLoader = () => {
  return (
    <Badge
      pill
      variant="secondary"
      style={{ padding: '3.5px 7px', margin: '4px 1px' }}
    >
      <Spinner
        animation="border"
        size="xs"
        role="status"
        aria-label="spinner"
      />
    </Badge>
  );
};

export default BadgeLoader;
